import React, { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import * as api from '../../api';
import { supabase } from '../../lib/supabaseClient';
import Spinner from '../Atoms/Spinner';
import VoteModal from '../Components/VoteModal';

// ─── Constants ──────────────────────────────────────────────
const EVENT_ID = '67590da5499bcc995c210b40';

const WINNER_PROJECT_IDS = [
    '67a332e21b103d938bafb0dc', '67a0b8331b103d938bafa954', '67aa1011740d844a3d633e93',
    '6829daa5754f51df2ef9141c', '67e6c18043d5609350e381a8', '67b5e6146890f1a147192905',
    '67be4a58b1ba28c3144aeb73', '67bf2330b1ba28c3144af8d2', '67c090dcdb48cb16a13c5b43',
    '677268097ec5d90c89d6fe63', '67c6b416db48cb16a13c73c7', '67ab652c07736060460b3b75',
    '68348986754f51df2ef9b87c', '67d15108d95ccf24eaf191df', '67d7d38c43d5609350e242a1',
    '67d82d2243d5609350e24c5e', '662adc507159e5b1b1da7c75', '67d8718c43d5609350e25c38',
    '67d1977243d5609350e218f2', '682b5c5f754f51df2ef93bbc', '67da910a43d5609350e274d7',
    '67e1864b43d5609350e2baeb', '67daebf343d5609350e27a9e', '67dd585043d5609350e28e57',
    '67dfeb0e43d5609350e2a360', '67e1452a43d5609350e2b066', '678675e2de3ed4a7001ab532',
    '67e2d05943d5609350e2cf97', '67e3e1cb43d5609350e304e5', '67e3e81543d5609350e308de',
    '67e3f02643d5609350e30a0a', '67e42d7043d5609350e32539', '67e42e5543d5609350e32570',
    '67e45c9843d5609350e329c0', '67e529f743d5609350e33a8c', '67e53aab43d5609350e340c3',
    '67e56ab043d5609350e3490f', '67e5764d43d5609350e34cb5', '67e57f5143d5609350e3519a',
    '67e5864c43d5609350e353a3', '67e58da443d5609350e3561d', '67e58ebc43d5609350e35665',
    '67e5ab6b43d5609350e35905', '67e6828d43d5609350e36b6a', '67e6acaf43d5609350e37832',
    '67e51ddb43d5609350e33667', '67e6c0a843d5609350e380cf', '67e6d53a43d5609350e38725',
    '67e6dfff43d5609350e38900', '67e7003c43d5609350e38bfc', '6834625c754f51df2ef9a4b1',
    '67ea99b76b7945ed1a576bae', '67f90250a0262e085d37088f', '67e1741a43d5609350e2b608',
    '67fe7a6c9167c049fff4e37e', '67ab6ade07736060460b3c16', '6810a343264e7745556acae1',
    '6800f4c59167c049fff51f5d', '6800b8529167c049fff50e47', '6800e76e9167c049fff5197f',
    '6800ef849167c049fff51c6f', '6800fad59167c049fff52224', '680113739167c049fff52d73',
    '680106139167c049fff525af', '680125219167c049fff53405', '680957ab9167c049fff5a7c2',
    '681164d36c8fbfe5e3c91e9e', '68020ef79167c049fff54015', '68025d069167c049fff56132',
    '680b728c9167c049fff5c8f7', '680249249167c049fff55a19', '68024ed89167c049fff55b90',
    '68025b1a9167c049fff56037', '680270379167c049fff566f5', '680274c09167c049fff567c8',
    '680275419167c049fff567de', '68027b389167c049fff56954', '680291609167c049fff56cad',
    '6802a3fc9167c049fff56f5f', '6849787b17dde4ca4c4bf043', '6849435a17dde4ca4c4be251',
    '6807cb759167c049fff58dd4', '6808c3f59167c049fff599c7', '6808c3859167c049fff599b1',
    '680fa4b19167c049fff5deee', '6801e2f49167c049fff53ce1', '680a54a09167c049fff5bbc4',
    '680b94b29167c049fff5cd49', '6810df4a264e7745556ad75d', '680fa3f89167c049fff5deb1',
    '680fa844a71ddf126b77b977', '680fa9f09167c049fff5e027', '6810c9b9264e7745556acf4d',
    '681125b66c8fbfe5e3c91c62', '6818cac19e656d77bc6c72fa', '6818d27e9e656d77bc6c75a3',
    '6818dbdf9e656d77bc6c78a0', '682d97b2754f51df2ef96070', '67fccffaa0262e085d370ddc',
    '680271809167c049fff5674a',
];

// ─── Styled Components ──────────────────────────────────────
const PageWrapper = styled.div`
    background: #fafbfc;
    min-height: 100vh;
    overflow-x: hidden;
    box-sizing: border-box;
`;

const HeroSection = styled.div`
    background: white;
    color: #1a1a1a;
    padding: 24px 20px 20px;
    text-align: center;
    border-bottom: 1px solid #eee;

    @media (max-width: 768px) {
        padding: 20px 16px 16px;
    }
`;

const HeroLogo = styled.img`
    max-width: 280px;
    margin-bottom: 10px;

    @media (max-width: 768px) {
        max-width: 200px;
    }
`;

const HeroTitle = styled.h1`
    font-size: 28px;
    font-weight: 700;
    margin: 0 0 8px 0;
    letter-spacing: 0.5px;
    text-transform: uppercase;

    @media (max-width: 768px) {
        font-size: 22px;
    }
`;

const HeroSubtitle = styled.p`
    font-size: 14px;
    color: #777;
    max-width: 560px;
    margin: 0 auto;
    line-height: 1.5;

    @media (max-width: 768px) {
        font-size: 13px;
    }
`;

const Container = styled.div`
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
`;

const ToolbarSection = styled.div`
    position: sticky;
    top: 0;
    z-index: 100;
    background: white;
    border-bottom: 1px solid #e8e8e8;
    padding: 16px 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
`;

const ToolbarInner = styled.div`
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;

    @media (max-width: 600px) {
        flex-direction: column;
        align-items: stretch;
    }
`;

const FilterTabs = styled.div`
    display: flex;
    gap: 6px;
`;

const FilterTab = styled.button`
    padding: 8px 20px;
    border-radius: 100px;
    border: 1.5px solid ${props => props.active ? 'rgb(24, 51, 189)' : '#ddd'};
    background: ${props => props.active ? 'rgb(24, 51, 189)' : 'white'};
    color: ${props => props.active ? 'white' : '#555'};
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    white-space: nowrap;

    &:hover {
        border-color: rgb(24, 51, 189);
        color: ${props => props.active ? 'white' : 'rgb(24, 51, 189)'};
    }
`;

const SearchInput = styled.input`
    padding: 10px 16px;
    border: 1.5px solid #ddd;
    border-radius: 100px;
    font-size: 14px;
    outline: none;
    width: 260px;
    transition: border-color 0.2s;

    &:focus {
        border-color: rgb(24, 51, 189);
        box-shadow: 0 0 0 3px rgba(24, 51, 189, 0.08);
    }

    &::placeholder { color: #bbb; }

    @media (max-width: 600px) {
        width: 100%;
    }
`;

const CountLabel = styled.span`
    font-size: 13px;
    color: #999;
    white-space: nowrap;
`;

const GridSection = styled.div`
    padding: 32px 0 60px;
`;

const ProjectGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 20px;

    @media (max-width: 1100px) {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    @media (max-width: 768px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 12px;
    }
    @media (max-width: 480px) {
        grid-template-columns: minmax(0, 1fr);
        max-width: 360px;
        margin: 0 auto;
    }
`;

const CardLink = styled.div`
    cursor: pointer;
    min-width: 0;
    overflow: hidden;
`;

const Card = styled.div`
    background: white;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #e8e8e8;
    transition: all 0.25s ease;
    position: relative;
    display: flex;
    flex-direction: column;

    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
        border-color: #ccc;
    }
`;

const CardImageWrapper = styled.div`
    position: relative;
    overflow: hidden;
    width: 100%;
    padding-top: 75%;
    background-color: #f0f0f0;
`;

const CardImage = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-color: #f0f0f0;
    transition: transform 0.3s ease;

    ${Card}:hover & {
        transform: scale(1.03);
    }
`;

const TypeBadge = styled.span`
    position: absolute;
    top: 10px;
    left: 10px;
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    z-index: 2;
    background: ${props => props.type === 'objet'
        ? 'rgba(24, 51, 189, 0.9)'
        : 'rgba(0, 137, 123, 0.9)'};
    color: white;
`;

const VotedOverlay = styled.div`
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 2;
    background: rgba(40, 167, 69, 0.9);
    color: white;
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 700;
`;

const CardBody = styled.div`
    padding: 16px;
    flex: 1;
    display: flex;
    flex-direction: column;
`;

const CardName = styled.h3`
    font-size: 15px;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0 0 4px 0;
    line-height: 1.3;
    height: 2.6em;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-transform: uppercase;
`;

const CardDesigner = styled.p`
    font-size: 13px;
    color: #888;
    margin: 0 0 12px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
`;

const VoteButton = styled.button`
    width: 100%;
    padding: 10px;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    background: ${props => props.voted
        ? 'linear-gradient(135deg, #28a745, #20c997)'
        : '#bbb'};
    color: white;

    &:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px ${props => props.voted
            ? 'rgba(40, 167, 69, 0.3)'
            : 'rgba(24, 51, 189, 0.3)'};
    }

    &:disabled {
        cursor: default;
    }
`;

const EmptyState = styled.div`
    text-align: center;
    padding: 60px 20px;
    color: #999;
    font-size: 16px;
`;

const LoadingWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 80px 20px;
`;

const BlurredContent = styled.div`
    filter: blur(12px);
    pointer-events: none;
    user-select: none;
`;

const ComingSoonOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 200;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.4);
`;

const ComingSoonCard = styled.div`
    background: white;
    border-radius: 16px;
    padding: 48px 40px;
    text-align: center;
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.15);
    max-width: 460px;
    margin: 0 20px;
`;

const ComingSoonTitle = styled.h2`
    font-size: 26px;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0 0 12px 0;
`;

const ComingSoonText = styled.p`
    font-size: 16px;
    color: #666;
    margin: 0;
    line-height: 1.6;
`;

// ─── Component ──────────────────────────────────────────────
const VoteFD100Page = ({ preview }) => {
    const { i18n } = useTranslation('common');
    const isFr = i18n.language === 'fr';
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const [loading, setLoading] = useState(true);
    const [definitiveNames, setDefinitiveNames] = useState({});
    const [projectsBasicData, setProjectsBasicData] = useState({});
    const [votedProjects, setVotedProjects] = useState(() =>
        JSON.parse(localStorage.getItem('fd100_voted_projects') || '[]')
    );
    const [filter, setFilter] = useState('all');
    const [search, setSearch] = useState('');
    const [voteModal, setVoteModal] = useState(null);

    // Capture UTM params and persist in sessionStorage for cross-page tracking
    useEffect(() => {
        const utmSource = searchParams.get('utm_source');
        if (utmSource) {
            const utm = {
                utm_source: utmSource,
                utm_medium: searchParams.get('utm_medium') || null,
                utm_campaign: searchParams.get('utm_campaign') || null,
                utm_content: searchParams.get('utm_content') || null,
            };
            sessionStorage.setItem('fd100_utm', JSON.stringify(utm));
        }
    }, [searchParams]);

    // Fetch names from Supabase + type/images from lightweight endpoint (parallel)
    useEffect(() => {
        Promise.all([
            supabase
                .from('fd100_project_names')
                .select('*')
                .eq('event_id', EVENT_ID),
            api.getProjectsBasicData({ projectIds: WINNER_PROJECT_IDS }),
        ]).then(([namesRes, basicRes]) => {
            if (namesRes.data) {
                const map = {};
                namesRes.data.forEach(item => {
                    map[item.project_id] = {
                        name_fr: item.name_definitive_fr,
                        name_en: item.name_definitive_en,
                        designer: item.designer_definitive,
                    };
                });
                setDefinitiveNames(map);
            }
            if (basicRes.data) {
                setProjectsBasicData(basicRes.data);
            }
            setLoading(false);
        }).catch(err => {
            console.error(err);
            setLoading(false);
        });
    }, []);

    // ─── Helpers ────────────────────────────────────────────
    const getProjectName = (pid) => {
        const def = definitiveNames[pid];
        if (def) return isFr ? (def.name_fr || def.name_en || pid) : (def.name_en || def.name_fr || pid);
        return pid;
    };

    const getDesignerName = (pid) => {
        return definitiveNames[pid]?.designer || '';
    };

    const getProjectType = (pid) => {
        return projectsBasicData[pid]?.type || 'objet';
    };

    const getProjectImage = (pid) => {
        const path = projectsBasicData[pid]?.imagePath;
        return path ? process.env.REACT_APP_MEDIA_BASE_URL + 'userfiles/' + path : null;
    };

    // Filter and search
    const filteredProjects = useMemo(() => {
        let result = [...WINNER_PROJECT_IDS];
        if (filter === 'objet') {
            result = result.filter(pid => getProjectType(pid) === 'objet');
        } else if (filter === 'espace') {
            result = result.filter(pid => getProjectType(pid) === 'espace');
        }
        if (search.trim()) {
            const q = search.trim().toLowerCase();
            result = result.filter(pid => {
                const name = getProjectName(pid).toLowerCase();
                const designer = getDesignerName(pid).toLowerCase();
                return name.includes(q) || designer.includes(q);
            });
        }
        // Sort alphabetical
        return result.sort((a, b) =>
            getProjectName(a).localeCompare(getProjectName(b))
        );
    }, [filter, search, definitiveNames, projectsBasicData, isFr]);

    const handleVoteClick = (e, pid) => {
        e.stopPropagation();
        setVoteModal(pid);
    };

    const handleVoteSuccess = (projectId) => {
        setVotedProjects(prev => [...prev, projectId]);
    };

    const handleCardClick = (pid) => {
        navigate(`/vote/fd100/${pid}`);
    };

    if (loading) {
        return (
            <PageWrapper>
                <HeroSection>
                    <HeroTitle>Prix du Public</HeroTitle>
                </HeroSection>
                <LoadingWrapper><Spinner /></LoadingWrapper>
            </PageWrapper>
        );
    }

    return (
        <PageWrapper>
                <HeroSection>
                    <HeroLogo src="/assets/fd100-kit/logos/SD25-FD100-Logo-Story.png" alt="Le FD100" />
                    <HeroTitle>
                        {isFr
                            ? 'Les 100 projets lauréats choisis par le jury international'
                            : 'The 100 winning projects chosen by the international jury'}
                    </HeroTitle>
                    <HeroSubtitle>
                        {isFr
                            ? 'Votez pour vos projets préférés. Un vote par projet, votez pour autant de projets que vous le souhaitez !'
                            : 'Vote for your favourite projects. One vote per project, vote for as many projects as you like!'}
                    </HeroSubtitle>
                </HeroSection>

                <ToolbarSection>
                    <ToolbarInner>
                        <FilterTabs>
                            <FilterTab active={filter === 'all'} onClick={() => setFilter('all')}>
                                {isFr ? 'Tous' : 'All'}
                            </FilterTab>
                            <FilterTab active={filter === 'objet'} onClick={() => setFilter('objet')}>
                                {isFr ? 'Objets' : 'Objects'}
                            </FilterTab>
                            <FilterTab active={filter === 'espace'} onClick={() => setFilter('espace')}>
                                {isFr ? 'Espaces' : 'Spaces'}
                            </FilterTab>
                        </FilterTabs>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <SearchInput
                                placeholder={isFr ? 'Rechercher un projet ou designer...' : 'Search project or designer...'}
                                value={search}
                                onChange={e => setSearch(e.target.value)}
                            />
                            <CountLabel>
                                {filteredProjects.length} {isFr ? 'projets' : 'projects'}
                            </CountLabel>
                        </div>
                    </ToolbarInner>
                </ToolbarSection>

                <GridSection>
                    <Container>
                        {filteredProjects.length === 0 ? (
                            <EmptyState>
                                {isFr ? 'Aucun projet trouvé.' : 'No projects found.'}
                            </EmptyState>
                        ) : (
                            <ProjectGrid>
                                {filteredProjects.map(pid => {
                                    const name = getProjectName(pid);
                                    const designer = getDesignerName(pid);
                                    const image = getProjectImage(pid);
                                    const type = getProjectType(pid);
                                    const isVoted = votedProjects.includes(pid);

                                    return (
                                        <CardLink key={pid} onClick={() => handleCardClick(pid)}>
                                            <Card>
                                                <CardImageWrapper>
                                                    <CardImage style={{ backgroundImage: image ? `url(${image})` : 'none' }} />
                                                    <TypeBadge type={type}>
                                                        {type === 'objet'
                                                            ? (isFr ? 'Objet' : 'Object')
                                                            : (isFr ? 'Espace' : 'Space')}
                                                    </TypeBadge>
                                                    {isVoted && (
                                                        <VotedOverlay>
                                                            &#10003; {isFr ? 'Voté' : 'Voted'}
                                                        </VotedOverlay>
                                                    )}
                                                </CardImageWrapper>
                                                <CardBody>
                                                    <CardName>{name}</CardName>
                                                    <CardDesigner>{designer}</CardDesigner>
                                                    <VoteButton
                                                        voted={isVoted}
                                                        disabled
                                                        onClick={e => e.stopPropagation()}
                                                    >
                                                        {isVoted
                                                            ? (isFr ? 'Vote enregistré' : 'Vote recorded')
                                                            : (isFr ? 'Votes clos' : 'Voting closed')}
                                                    </VoteButton>
                                                </CardBody>
                                            </Card>
                                        </CardLink>
                                    );
                                })}
                            </ProjectGrid>
                        )}
                    </Container>
                </GridSection>
            {voteModal && (
                <VoteModal
                    projectId={voteModal}
                    projectName={getProjectName(voteModal)}
                    projectImage={getProjectImage(voteModal)}
                    designerName={getDesignerName(voteModal)}
                    onClose={() => setVoteModal(null)}
                    onVoteSuccess={handleVoteSuccess}
                    utmParams={JSON.parse(sessionStorage.getItem('fd100_utm') || 'null')}
                />
            )}
        </PageWrapper>
    );
};

export default VoteFD100Page;
